<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户PO</label>
            <span class="weui-form-preview__value">{{initData.sa_pocode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户名称</label>
            <span class="weui-form-preview__value">{{initData.sa_custname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币种</label>
            <span class="weui-form-preview__value">{{initData.sa_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">付款方式</label>
            <span class="weui-form-preview__value">{{initData.sa_payments}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">联系人</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">
              {{initData.sa_custcontact || ''}}
              {{initData.sa_custmobile || ''}}
              <call-mobile :mobile="initData.sa_custmobile"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">收货地址</label>
            <span 
              class="weui-form-preview__value" 
              :class="{
                'weui-form-preview__value-icon': !!initData.sa_toplace,
              }"
            >
              {{initData.sa_toplace}}
              <router-link
                v-if="initData.sa_toplace"
                class="iconfont icon-map"
                :to="'/map/baidu?keywords=' + initData.sa_toplace"
              ></router-link>
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">下单日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.sa_date}}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview" v-for="item in initData.orderDetails" :key="item.sd_detno">
          <div class="form-detail-preview_num">{{ item.sd_detno }}</div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户物料编号</label>
            <span class="weui-form-preview__value">{{item.sd_custprodcode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{item.sd_custproddetail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{item.sd_custorispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">数量</label>
            <span class="weui-form-preview__value">{{item.sd_qty}} {{item.sd_custprodunit}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">含税单价（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.sd_price}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">交货日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.sd_delivery}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">价税合计（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.sd_total}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.productDTO">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{item.productDTO.pr_code}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.productDTO">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{item.productDTO.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.productDTO">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{item.productDTO.pr_spec}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bar weui-dialog__ft">
      <div class="weui-dialog__btn weui-dialog__btn_primary" @click="gotoView">转销售订单</div>
    </div>
  </div>
</template>

<script>
import CallMobile from "@/components/button/CallMobile.vue";

export default {
  components: {
    CallMobile
  },
  props: {
    initData: Object
  },
  methods: {
    gotoView() {
      let item = this.initData
      this.$router.push({
        name: 'SaleOrderEdit',
        params: {
          itemData: Object.assign({}, item),
        },
      });
    },
  },
};
</script>